<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <div class="product-content" style="width: 60%">
      <el-row class="border b-radius-2" style="background: #FBFBFB;">
        <el-col :span="12">
          <div style="min-height: 100%">
            <div style="background: #F3F3F3" class="h-40 p-12 bold">
              订单信息
            </div>
            <div class="p-12">
              <div class="pb16">
                <span class="gray9">收货地址：</span>
                {{ detail.address.region ? detail.address.region.province || '' : '' }}
                {{ detail.address.region ? detail.address.region.city || '' : '' }}
                {{ detail.address.region ? detail.address.region.region || '' : '' }}
                {{ detail.address.detail || '' }} <span class="pl16" style="color: #3a8ee6;cursor: pointer"
                                                        v-if="detail.deliveryStatus != 20 && detail.orderStatus == 10"
                                                        @click="changeAdd">修改地址 </span>
              </div>
              <div class="pb16">
                <span class="gray9">收货人：</span>
                {{ detail.address.name }} / {{ detail.address.phone }}
              </div>
              <div class="pb16">
                <span class="gray9">订单号：</span>
                {{ detail.orderNo }}
              </div>
              <div class="pb16">
                <span class="gray9">买家留言：</span>
                {{ detail.buyerRemark }} <span class="pl16" style="color: #3a8ee6;cursor: pointer"
                                               v-if="detail.deliveryStatus != 20 && detail.orderStatus == 10"
                                               @click="changeRemarkAdd">修改留言 </span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="border-l" style="background: white">
          <div style="min-height: 200px;">
            <div style="background: #F3F3F3" class="h-40 p-12 flex j-between">
              <div class="bold">物流跟踪</div>
              <div :style="{color:getShowStatusColor}"> {{ detail.orderStatusText }}</div>
            </div>
            <div style="display: block;max-height: 400px" class="p-10 o-y-auto">
              <div v-if="detail.expressDetail && detail.expressDetail.length">
                <div v-for="(item,index) in detail.expressDetail" :key="index">
                  <div class="m-v-5">
                    <span class="fs-16 bold">物流单号：{{ item.nu }}</span>
                  </div>
                  <el-timeline
                    v-if="item && item.data && item.data.length ">
                    <el-timeline-item
                      v-for="(citem, cindex) in item.data"
                      :key="cindex"
                      :color="cindex===0?'red':''"
                      size="normal"
                      :timestamp="citem.time">
                      <span :style="{color:cindex===0?'red':''}">{{ citem.context }} - {{ citem.status }}</span>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-steps :active="getActive" align-center class="m-t-30" finish-status="finish">
        <el-step title="新订单" :description="detail.createTime" icon="el-icon-success"></el-step>
        <el-step :title="detail.payStatus === 20? '完成付款' :'待付款'" :description="detail.payTime"
                 icon="el-icon-success"></el-step>
        <el-step :title="detail.deliveryStatus === 20?'商家发货': '待发货'" :description="detail.deliveryTime"
                 icon="el-icon-success"></el-step>
        <el-step :title="detail.receiptStatus === 20?'已收货':'确认收货'" :description="detail.receiptTime"
                 icon="el-icon-success"></el-step>
        <el-step title="完成" icon="el-icon-success"></el-step>
      </el-steps>

      <div class="table-wrap m-t-30">
        <el-table size="small" :span-method="arraySpanMethod" :data="detail.productList" border style="width: 100%">
          <el-table-column prop="productName" label="商品" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.isTopRow === 1">
                <span>支付方式：{{ scope.row.payTypeText }}</span>
                <span class="pl16" v-if="detail.deliveryTypeText">配送方式：{{ detail.deliveryTypeText }}</span>
                <span class="pl16"
                      v-if="detail.express">物流公司：{{ detail.express ? detail.express.expressName || '' : '' }}</span>
                <span class="pl16" v-if="detail.expressNo">物流单号：{{ detail.expressNo }}</span>
                <span class="pl16" v-if="detail.couponsId">卡券：{{ detail.packetNo }} </span>
              </div>
              <div class="flex-column j-start" style="align-items: flex-end" v-else-if="scope.row.isTopRow === 3">
                <div class="pr16 pt16 fs-13">
                  <span class="gray9">订单金额 (元)：</span>{{ detail.orderPrice }}
                </div>
                <div class="pb16 fs-13" v-if="detail.pointsMoney > 0">
                  <span class="gray9">积分抵扣 (元)：</span>
                  {{ detail.pointsMoney }}
                </div>
                <div class="pr16 fs-13">
                  <span class="gray9 ">运费金额 (元)：</span>{{ detail.expressPrice }}
                </div>
                <div class="pr16 fs-13" v-if="detail.couponsId">
                  <span class="gray9 ">卡券金额 (元)：</span>{{ detail.couponsPrice }}
                </div>
                <div class="pr16">
                  <!--                  <span @click="editClick(detail)" style="color: #3a8ee6;cursor: pointer"-->
                  <!--                        v-if="detail.payStatus == 10 && detail.orderStatus == 10 && detail.orderSource == 10"-->
                  <!--                        v-auth="'/order/order/updatePrice'">修改价格</span>-->
                  <span class="gray9 pl16 bold fs-14">订单应付金额：</span> <span class="fs-16 text-red">{{
                    detail.payPrice
                  }}</span> <span class="fs-14 bold">元</span>
                </div>
              </div>
              <template v-else>
                <div class="product-info">
                  <div class="pic"><img v-img-url="scope.row.imagePath"/></div>
                  <div class="info">
                    <div class="name">{{ scope.row.productName }}</div>
                    <!-- <div class="gray9" v-if="scope.row.productAttr!=''">{{scope.row.productAttr}}</div>
                    <div class="orange" v-if="scope.row.refund">
                      {{ scope.row.refund.type.text }}-{{ scope.row.refund.status.text }}
                    </div> -->
                    <div class="price">
                    <span :class="{ 'text-d-line': scope.row.isUserGrade == 1, gray6: scope.row.isUserGrade != 1 }">￥ {{
                        scope.row.productPrice
                      }}</span>
                      <span class="ml10" v-if="scope.row.isUserGrade == 1">会员折扣价：￥ {{
                          scope.row.gradeProductPrice
                        }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="productNo" label="商品编码"></el-table-column>
          <el-table-column prop="productWeight" label="重量 (Kg)"></el-table-column>
          <el-table-column prop="totalNum" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ scope.row.totalNum }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="商品总价(元)">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.totalPrice }}</p>
            </template>
          </el-table-column>
          <!--表单信息-->
          <!--         <el-table-column prop="totalPrice" label="表单信息">
            <template slot-scope="scope">
              <div v-if="scope.row.table_record_id > 0">
                <div v-for="(item, index) in scope.row.tableData" :key="index">
                  {{item.name}}:{{item.value}}
                </div>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <!--内容-->
    <!--    <div class="product-content">-->
    <!--      &lt;!&ndash;基本信息&ndash;&gt;-->
    <!--      <div class="common-form">基本信息</div>-->
    <!--      <div class="table-wrap">-->
    <!--        <el-row>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">订单号：</span>-->
    <!--              {{ detail.orderNo }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">买家：</span>-->
    <!--              {{ detail.nickname }}-->
    <!--              <span>用户ID：({{ detail.userId }})</span>-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">订单金额 (元)：</span>-->
    <!--              {{ detail.orderPrice }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">运费金额 (元)：</span>-->
    <!--              {{ detail.expressPrice }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16" v-if="detail.couponMoney > 0">-->
    <!--              <span class="gray9">优惠券抵扣 (元)：</span>-->
    <!--              {{ detail.couponMoney }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16" v-if="detail.pointsMoney > 0">-->
    <!--              <span class="gray9">积分抵扣 (元)：</span>-->
    <!--              {{ detail.pointsMoney }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16" v-if="detail.fullreduceMoney > 0">-->
    <!--              <span class="gray9">满减金额 (元)：</span>-->
    <!--              {{ detail.fullreduceMoney }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16" v-if="detail.productReduceMoney > 0">-->
    <!--              <span class="gray9">商品满减 (元)：</span>-->
    <!--              {{ detail.productReduceMoney }}-->
    <!--            </div>-->
    <!--          </el-col>-->

    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">实付款金额 (元)：</span>-->
    <!--              {{ detail.payPrice }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">支付方式：</span>-->
    <!--              {{ detail.payTypeText }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">配送方式：</span>-->
    <!--              {{ detail.deliveryTypeText }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">交易状态：</span>-->
    <!--              {{ detail.orderStatusText }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          &lt;!&ndash; <el-col :span="5" v-if="detail.orderSource==80">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">定金：</span>-->
    <!--              {{ detail.advance.payPrice }}-->
    <!--            </div>-->
    <!--          </el-col>-->
    <!--          <el-col :span="5" v-if="detail.orderSource==80">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">尾款：</span>-->
    <!--              {{ detail.payPrice }}-->
    <!--            </div>-->
    <!--          </el-col> &ndash;&gt;-->
    <!--          &lt;!&ndash; <el-col :span="5" v-if="detail.orderSource==80&&detail.advance.reduceMoney">-->
    <!--            <div class="pb16">-->
    <!--              <span class="gray9">尾款立减：</span>-->
    <!--              {{ detail.advance.reduceMoney }}-->
    <!--            </div>-->
    <!--          </el-col> &ndash;&gt;-->
    <!--          <el-col :span="5" v-if="detail.payStatus == 10 && detail.orderStatus == 10 && detail.orderSource == 10"-->
    <!--                  v-auth="'/order/order/updatePrice'">-->
    <!--            <el-button @click="editClick(detail)" size="small">修改价格</el-button>-->
    <!--          </el-col>-->
    <!--        </el-row>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 编辑 &ndash;&gt;-->
    <!--      <Add v-if="open_edit" :open_edit="open_edit" :order="userModel" @close="closeDialogFunc($event, 'edit')"></Add>-->
    <!--      &lt;!&ndash;商品信息&ndash;&gt;-->
    <!--      <div class="common-form mt16">商品信息</div>-->
    <!--      <div class="table-wrap">-->
    <!--        <el-table size="small" :data="detail.productList" border style="width: 100%">-->
    <!--          <el-table-column prop="productName" label="商品" width="400">-->
    <!--            <template slot-scope="scope">-->
    <!--              <div class="product-info">-->
    <!--                <div class="pic"><img v-img-url="scope.row.imagePath"/></div>-->
    <!--                <div class="info">-->
    <!--                  <div class="name">{{ scope.row.productName }}</div>-->
    <!--                  &lt;!&ndash; <div class="gray9" v-if="scope.row.productAttr!=''">{{scope.row.productAttr}}</div>-->
    <!--                  <div class="orange" v-if="scope.row.refund">-->
    <!--                    {{ scope.row.refund.type.text }}-{{ scope.row.refund.status.text }}-->
    <!--                  </div> &ndash;&gt;-->
    <!--                  <div class="price">-->
    <!--                    <span :class="{ 'text-d-line': scope.row.isUserGrade == 1, gray6: scope.row.isUserGrade != 1 }">￥ {{-->
    <!--                        scope.row.productPrice-->
    <!--                      }}</span>-->
    <!--                    <span class="ml10" v-if="scope.row.isUserGrade == 1">会员折扣价：￥ {{-->
    <!--                        scope.row.gradeProductPrice-->
    <!--                      }}</span>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--          <el-table-column prop="productNo" label="商品编码"></el-table-column>-->
    <!--          <el-table-column prop="productWeight" label="重量 (Kg)"></el-table-column>-->
    <!--          <el-table-column prop="totalNum" label="购买数量">-->
    <!--            <template slot-scope="scope">-->
    <!--              <p>x {{ scope.row.totalNum }}</p>-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--          <el-table-column prop="totalPrice" label="商品总价(元)">-->
    <!--            <template slot-scope="scope">-->
    <!--              <p>￥ {{ scope.row.totalPrice }}</p>-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--          &lt;!&ndash;表单信息&ndash;&gt;-->
    <!--          &lt;!&ndash;         <el-table-column prop="totalPrice" label="表单信息">-->
    <!--            <template slot-scope="scope">-->
    <!--              <div v-if="scope.row.table_record_id > 0">-->
    <!--                <div v-for="(item, index) in scope.row.tableData" :key="index">-->
    <!--                  {{item.name}}:{{item.value}}-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </template>-->
    <!--          </el-table-column> &ndash;&gt;-->
    <!--        </el-table>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 收货信息 &ndash;&gt;-->
    <!--      <div>-->
    <!--        <div class="common-form mt16">收货信息</div>-->
    <!--        <div class="table-wrap">-->
    <!--          <el-row>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">收货人：</span>-->
    <!--                {{ detail.address.name }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">收货电话：</span>-->
    <!--                {{ detail.address.phone }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">收货地址：</span>-->
    <!--                {{ detail.address.region.province }} {{ detail.address.region.city }} {{ detail.address.region.region }}-->
    <!--                {{ detail.address.detail }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5" v-if="detail.deliveryStatus != 20 && detail.orderStatus == 10">-->
    <!--              <div class="pb16">-->
    <!--                <el-button type="text" size="small" @click="changeAdd">修改地址</el-button>-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--          <el-row>-->
    <!--            <el-col :span="25">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">备注：</span>-->
    <!--                {{ detail.buyerRemark }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 自提提货站点信息 &ndash;&gt;-->
    <!--      &lt;!&ndash;无需发货&ndash;&gt;-->
    <!--      <template v-if="detail.deliveryType == 30">-->
    <!--        <div class="common-form mt16">用户信息</div>-->
    <!--        <div class="table-wrap">-->
    <!--          <el-row>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">联系手机：</span>-->
    <!--                {{ detail.mobile }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--          <el-row>-->
    <!--            <el-col :span="25">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">备注：</span>-->
    <!--                {{ detail.buyerRemark }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--      &lt;!&ndash;付款信息&ndash;&gt;-->
    <!--      <div class="table-wrap" v-if="detail.payStatus == 20">-->
    <!--        <div class="common-form mt16">付款信息</div>-->
    <!--        <div class="table-wrap">-->
    <!--          <el-row>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">应付款金额：</span>-->
    <!--                {{ detail.payPrice }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">支付方式：</span>-->
    <!--                {{ detail.payTypeText }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">支付流水号：</span>-->
    <!--                {{ detail.transactionId }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">付款状态：</span>-->
    <!--                {{ detail.payStatusText }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">付款时间：</span>-->
    <!--                {{ detail.payTime }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;  用户取消订单 &ndash;&gt;-->
    <!--      <div v-if="detail.payStatus == 20 && detail.orderStatus == 21" v-auth="'/order/operate/confirmCancel'">-->
    <!--        <div class="common-form mt16">用户取消订单</div>-->
    <!--        <p class="red pb16">-->
    <!--          当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>-->
    <!--        <el-form size="small" ref="forms" :model="forms">-->
    <!--          <el-form-item label="审核状态">-->
    <!--            <div>-->
    <!--              <el-radio v-model="forms.isCancel" :label="1">同意</el-radio>-->
    <!--              <el-radio v-model="forms.isCancel" :label="0">拒绝</el-radio>-->
    <!--            </div>-->
    <!--          </el-form-item>-->
    <!--        </el-form>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;发货信息&ndash;&gt;-->
    <!--      <div-->
    <!--        v-if="detail.payStatus == 20 && [20, 21].indexOf(detail.orderStatus) === -1 && (detail.isSelfOrder == 1 || detail.shopSupplierId === detail.agentId)"-->
    <!--        v-auth="'/order/order/delivery'">-->
    <!--        <div v-if="detail.deliveryType == 10 &&detail.deliveryStatus == 10">-->
    <!--          &lt;!&ndash; 去发货 &ndash;&gt;-->
    <!--          <div class="common-form mt16">去发货</div>-->
    <!--          <el-form size="small" ref="form" :model="form" label-width="100px">-->
    <!--            <el-form-item label="物流公司">-->
    <!--              <el-select v-model="form.expressId" placeholder="请选择快递公司">-->
    <!--                <el-option :label="item.expressName" v-for="(item, index) in expressList" :key="index"-->
    <!--                           :value="item.expressId"></el-option>-->
    <!--              </el-select>-->
    <!--            </el-form-item>-->
    <!--            <el-form-item label="物流单号">-->
    <!--              <el-input v-model="form.expressNo" class="max-w460"></el-input>-->
    <!--            </el-form-item>-->
    <!--          </el-form>-->
    <!--        </div>-->
    <!--        <div v-if="detail.deliveryType == 20 && detail.deliveryStatus == 10">-->
    <!--          <div class="common-form mt16">去发货</div>-->
    <!--          <el-row>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">自提提货站点名称：</span>-->
    <!--                {{ detail.extractStoreName }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">收货人：</span>-->
    <!--                {{ detail.extractStore ? detail.extractStore.linkman || '' : '' }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">收货电话：</span>-->
    <!--                {{ detail.extractStore ? detail.extractStore.phone || '' : '' }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--        </div>-->
    <!--        <div v-if="detail.deliveryStatus == 20">-->
    <!--          <div class="common-form mt16">发货信息</div>-->
    <!--          <div class="table-wrap">-->
    <!--            <el-row>-->
    <!--              <el-col :span="5" v-if="detail.deliveryType == 10">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">物流公司：</span>-->
    <!--                  {{ detail.express.expressName }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5" v-if="detail.deliveryType == 10">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">物流单号：</span>-->
    <!--                  {{ detail.expressNo }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5" v-if="detail.deliveryType == 20">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">自提提货站点名称：</span>-->
    <!--                  {{ detail.extractStoreName }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5" v-if="detail.deliveryType == 20">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">收货人：</span>-->
    <!--                  {{ detail.extractStore ? detail.extractStore.linkman || '' : '' }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5" v-if="detail.deliveryType == 20">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">收货电话：</span>-->
    <!--                  {{ detail.extractStore ? detail.extractStore.phone || '' : '' }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">发货状态：</span>-->
    <!--                  {{ detail.deliveryStatusText }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">发货时间：</span>-->
    <!--                  {{ detail.deliveryTime }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;取消信息&ndash;&gt;-->
    <!--      <div class="table-wrap" v-if="detail.orderStatus == 20 && detail.cancelRemark != ''">-->
    <!--        <div class="common-form mt16">取消信息</div>-->
    <!--        <div class="table-wrap">-->
    <!--          <el-row>-->
    <!--            <el-col :span="5">-->
    <!--              <div class="pb16">-->
    <!--                <span class="gray9">商家备注：</span>-->
    <!--                {{ detail.cancelRemark }}-->
    <!--              </div>-->
    <!--            </el-col>-->
    <!--          </el-row>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      &lt;!&ndash;提货站点自提核销&ndash;&gt;-->
    <!--      <div-->
    <!--        v-if="detail.deliveryType == 20 && detail.payStatus == 20 && detail.orderStatus != 21 && detail.orderStatus != 20 && (detail.isSelfOrder == 2 || detail.shopSupplierId === detail.agentId)">-->
    <!--        <div class="common-form mt16">自提核销</div>-->
    <!--        <div v-if="detail.orderStatus!=30">-->
    <!--          <el-form size="small" ref="extract_form" :model="extract_form" label-width="100px">-->
    <!--            <el-form-item label="核销专员">-->
    <!--              <el-select v-model="extractClerkId" placeholder="点击选择">-->
    <!--                <el-option :label="item.realName" v-for="(item, index) in shopClerkList" :key="item.clerkId"-->
    <!--                           :value="item.clerkId"></el-option>-->
    <!--              </el-select>-->
    <!--            </el-form-item>-->
    <!--            <el-form-item label="买家取货状态 ">-->
    <!--              <el-radio v-model="extract_form.order.extractStatus" :label="1">已取货</el-radio>-->
    <!--            </el-form-item>-->
    <!--            <el-form-item>-->
    <!--              <el-button type="primary" @click="onExtract(detail.orderId)">确认核销</el-button>-->
    <!--            </el-form-item>-->
    <!--          </el-form>-->
    <!--        </div>-->
    <!--        <div v-else class="table-wrap">-->
    <!--          <template v-if="detail.extractClerkId">-->
    <!--            <el-row>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">自提提货站点名称：</span>-->
    <!--                  {{ detail.extractStoreName }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">核销专员：</span>-->
    <!--                  {{ detail.extractClerkName }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">核销状态：</span>-->
    <!--                  <template v-if="detail.deliveryStatus == 20">-->
    <!--                    已核销-->
    <!--                  </template>-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">核销时间：</span>-->
    <!--                  {{ detail.deliveryTime }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </template>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;虚拟物品发货&ndash;&gt;-->
    <!--      <div-->
    <!--        v-if="detail.deliveryType == 30 && detail.payStatus == 20 && detail.orderStatus != 21 && detail.orderStatus != 20"-->
    <!--        v-auth="'/order/order/delivery'">-->
    <!--        <div class="common-form mt16">虚拟商品发货</div>-->
    <!--        <div v-if="detail.deliveryStatus == 10">-->
    <!--          <el-form size="small" ref="virtualForm" :model="virtualForm" label-width="100px">-->
    <!--            <el-form-item label="发货信息">-->
    <!--              <el-input v-model="virtualForm.virtualContent" class="max-w460"></el-input>-->
    <!--            </el-form-item>-->
    <!--            <el-form-item>-->
    <!--              <el-button type="primary" @click="onVirtual(detail.orderId)">确认发货</el-button>-->
    <!--            </el-form-item>-->
    <!--          </el-form>-->
    <!--        </div>-->
    <!--        <div v-else class="table-wrap">-->
    <!--          <template v-if="detail.virtualContent">-->
    <!--            <el-row>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">发货信息：</span>-->
    <!--                  {{ detail.virtualContent }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">发货状态：</span>-->
    <!--                  <template v-if="detail.deliveryStatus == 20">-->
    <!--                    已发货-->
    <!--                  </template>-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--              <el-col :span="5">-->
    <!--                <div class="pb16">-->
    <!--                  <span class="gray9">发货时间：</span>-->
    <!--                  {{ detail.deliveryTime }}-->
    <!--                </div>-->
    <!--              </el-col>-->
    <!--            </el-row>-->
    <!--          </template>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
      <!--确认发货-->
      <!--      <template-->
      <!--        v-if="detail.payStatus === 20 && [20, 21].indexOf(detail.orderStatus) === -1 && detail.isSelfOrder == 1">-->
      <!--        <el-button size="small" type="primary" @click="onSubmit" v-if="detail.deliveryStatus == 10">确认发货</el-button>-->
      <!--      </template>-->
      <!--用户取消-->
      <!--      <template v-if="detail.payStatus == 20 && detail.orderStatus == 21">-->
      <!--        <el-button size="small" type="primary" @click="confirmCancel()">确认审核</el-button>-->
      <!--      </template>-->
    </div>
    <changeAddress v-if="addressData != null" :isChange="isChange" :addressData="addressData"
                   @closeDialog="closeAddress"></changeAddress>

    <el-dialog title="买家留言" :visible.sync="isRemarkChange" :close-on-click-modal="false" :show-close="false"
               :close-on-press-escape="false" width="900px">
      <el-input class="mb16" type="textarea" size="small" v-model="editForm.buyerRemark"
                :rows="4" resize="none"
                placeholder="请输入买家留言"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="isRemarkChange=false">取 消</el-button>
        <el-button size="small" type="primary" @click="onRemarkChangeOK">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import changeAddress from '@/components/order/changeAddress.vue'
import Add from './dialog/Add.vue'
import {deepClone} from '@/utils/base.js'

export default {
  components: {
    Add,
    changeAddress
  },
  data () {
    return {
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      detail: {
        payStatus: [],
        payType: [],
        deliveryType: [],
        user: {},
        address: [],
        product: [],
        orderStatus: [],
        extract: [],
        extractStoreId: [],
        express: [],
        deliveryStatus: [],
        extractClerk: {}
      },
      extractClerkId: '',
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        expressId: null,
        /*订单号*/
        expressNo: ''
      },
      forms: {
        is_cancel: 1
      },
      extract_form: {
        order: {
          extractStatus: 1
        }
      },
      /*虚拟商品发货*/
      virtualForm: {
        virtualContent: ''
      },
      order: {},
      deliveryType: 0,
      /*配送方式*/
      exStyle: [],
      /*提货站点列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {},
      /*时间*/
      createTime: '',
      /*快递公司列表*/
      expressList: [],
      shopClerkList: [],
      isChange: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      addressData: null,
      isRemarkChange: false,
      editForm: {
        orderId: 0,
        buyerRemark: ''
      }
    }
  },
  computed: {
    getShowStatusColor () {
      let text = ''
      let orderStatus = this.detail.orderStatus
      let payStatus = this.detail.payStatus
      let deliveryStatus = this.detail.deliveryStatus
      if (orderStatus === 20) {
        return '#999999'
      }
      if (orderStatus === 30) {
        return '#333333'
      }

      if (payStatus === 10) {
        return '#FF453A'
      }

      if (deliveryStatus === 10) {
        return '#FF9500'
      }

      if (deliveryStatus === 20) {
        return '#FFCC00'
      }
      return text
    },
    getActive () {
      let active = 0
      let orderStatus = this.detail.orderStatus
      let payStatus = this.detail.payStatus
      let deliveryStatus = this.detail.deliveryStatus
      if (orderStatus === 30) {
        return 4
      }
      if (payStatus === 10) {
        return 1
      }
      if (deliveryStatus === 10) {
        return 2
      }
      if (deliveryStatus === 20) {
        return 3
      }
      return active
    }
  },
  created () {
    /*获取列表*/
    this.getParams()
  },
  methods: {
    arraySpanMethod (row) {
      console.log('arraySpanMethod:', row)
      if (row.row.isTopRow === 1 || row.row.isTopRow === 3) {
        if (row.columnIndex === 0) {
          return [1, 5]
        }
      }
    },
    next () {
      if (this.active++ > 4) this.active = 0
    },
    /*获取参数*/
    getParams () {
      let self = this
      // 取到路由带过来的参数
      const params = this.$route.query.orderId
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(res => {
          self.loading = false
          let productList = []
          let oldProductList = res.data.productList || []
          let translateList = oldProductList.map(item => {
            return {
              ...item,
              isTopRow: 2,
            }
          })
          let topItem = {
            payTypeText: res.data.payTypeText,
            isTopRow: 1
          }
          let bottomItem = {
            isTopRow: 3
          }
          productList.push(topItem)
          productList = productList.concat(translateList)
          productList.push(bottomItem)

          res.data.productList = productList
          self.detail = res.data
          console.log(self.detail.deliveryStatus == 10)
          self.expressList = res.data.expressList
          self.shopClerkList = res.data.shopClerkList
          self.addressData = res.data.address
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*发货*/
    onSubmit () {
      let self = this
      let param = self.form
      if (param.deliveryType === 10) {
        if (param.expressId == null) {
          this.$message.error('请选择物流公司')
          return
        }
        if (param.expressNo == '') {
          this.$message.error('请填写物流单号')
          return
        }
      }
      let orderId = this.$route.query.orderId
      OrderApi.delivery(
        {
          expressId: param.expressId,
          expressNo: param.expressNo,
          orderId: orderId
        },
        true
      )
        .then(data => {
          self.loading = false
          self.$message({
            message: '恭喜你，发货成功',
            type: 'success'
          })
          self.getParams()
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*确认取消*/
    confirmCancel () {
      let self = this
      let orderId = this.$route.query.orderId
      let isCancel = self.forms.isCancel
      OrderApi.confirm(
        {
          orderId: orderId,
          isCancel: isCancel
        },
        true
      )
        .then(data => {
          self.loading = false
          self.$message({
            message: '恭喜你，审核成功',
            type: 'success'
          })
          self.getParams()
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*核销*/
    onExtract (e) {
      let self = this
      let extract_form = self.extract_form
      let param = {}
      param.orderId = e
      param.extractStatus = extract_form.order.extractStatus
      param.extractClerkId = self.extractClerkId
      OrderApi.extract(param, true)
        .then(data => {
          self.loading = false
          self.$message({
            message: '恭喜你，操作成功',
            type: 'success'
          })
          self.getParams()
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*虚拟商品发货*/
    onVirtual (e) {
      let self = this
      let virtualForm = self.virtualForm
      if (virtualForm.virtualContent == '') {
        this.$message.error('请填写发货信息')
        return
      }
      virtualForm.orderId = e
      OrderApi.virtual(
        {
          orderId: virtualForm.orderId,
          virtualContent: virtualForm.virtualContent
        },
        true
      )
        .then(data => {
          self.loading = false
          self.$message({
            message: '恭喜你，操作成功',
            type: 'success'
          })
          self.getParams()
        })
        .catch(error => {
          self.loading = false
        })
    },

    closeAddress (e) {
      let self = this
      if (e == false) {
        self.isChange = false
        return false
      }
      let params = e.params
      params.orderId = self.$route.query.orderId
      OrderApi.updateAddress(params,
        true
      )
        .then(data => {
          self.getParams()
          self.$message({
            message: '修改成功',
            type: 'success'
          })
        })
        .catch(error => {

        })
      self.isChange = false
    },

    /*打开编辑*/
    editClick (item) {
      this.userModel = deepClone(item)
      this.open_edit = true
    },

    /*关闭弹窗*/
    closeDialogFunc (e, f) {
      if (f == 'edit') {
        this.open_edit = e.openDialog
        this.getParams()
      }
    },

    /*取消*/
    cancelFunc () {
      this.$router.back(-1)
    },

    changeAdd () {
      this.isChange = true
    },
    changeRemarkAdd () {
      this.editForm = {
        orderId: this.$route.query.orderId,
        buyerRemark: this.detail.buyerRemark || ''
      }
      this.isRemarkChange = true
    },
    onRemarkChangeOK () {
      let self = this
      let params = this.editForm
      OrderApi.updateRemark(params, true).then(data => {
        self.getParams()
        this.isRemarkChange = false
        self.$message({
          message: '修改成功',
          type: 'success'
        })
      }).catch(error => {

      })

    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/detail.vue